import { createFileRoute } from '@tanstack/react-router'

// /offers/$offerId (offer selected, no sub-view): renders nothing into the (collapsed) detail Outlet.
// The parent `offers.$offerId` layout now provides `offerId` to useParams (so the applicants panel
// treats the offer as selected) and owns the offer-chrome prefetch, so this leaf needs no loader.
export const Route = createFileRoute('/_app/offers/_list/$offerId/')({})
